const BACKEND = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem('token');

// Fetch all banners
export const fetchBanners = async () => {
  try {
    const response = await fetch(`${BACKEND}/banners`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
      },
    });

    const result = await response.json();
    if (response.ok) {
      console.log("All Banners", result.banners);
      return result.banners;
    } else {
      throw new Error(result.message || "Error fetching banners.");
    }
  } catch (error) {
    console.error("Error fetching banners:", error);
    throw error;
  }
};

export const addBanner = async (formData) => {
  try {
    const response = await fetch(`${BACKEND}/bannerpromotion`, {
      method: 'POST',
      body: formData,
    });

    const result = await response.json();

    if (response.status === 201) {
      console.log("Banner Added")
      return result.banner
      ;  
    } else {
      throw new Error(result.message);
    }
  } catch (error) {
    console.error('Error adding banner:', error);
    throw new Error('Failed to add banner');
  }
};

// Delete a banner by ID
export const deleteBanner = async (id) => {
  try {
    const response = await fetch(`${BACKEND}/banner/${id}`, {
      method: "DELETE",
    });
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "Error deleting banner.");
    }
    return result;
  } catch (error) {
    console.error("Error deleting banner:", error);
    throw error;
  }
};


export const togglePublished = async (id) => {
    try {
      const response = await fetch(`${BACKEND}/banner/${id}/toggle`, {
        method: "PUT",
      });
      const result = await response.json();
      if (response.ok) {
        return result;
      } else {
        throw new Error(result.message);
      }
    } catch (error) {
      console.error("Error toggling published status:", error);
      throw new Error("Failed to update banner published status");
    }
  };

 

  export const updateBanner = async (formData) => {
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    const response = await fetch(`${BACKEND}/update-banner/${formData.get('bannerId')}`, {
      method: "PUT",
      body: formData, 
    });
  
    if (!response.ok) {
      throw new Error('Failed to update banner');
    }
    return response.json(); 
  };
  
  